import api from '@/apis'
import router from '@/router'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    loading: false,
    type: null,
    avatars: [],

    select_avatar_btn_disable: false
  },
  mutations: {
    SET_VIRTUAL_AVATAR_LOADING(state, payload) {
      state.loading = payload
    },
    SET_VIRTUAL_AVATAR_TYPE(state, payload) {
      state.type = payload
    },
    SET_VIRTUAL_AVATAR_AVATARS(state, payload) {
      state.avatars = payload
    },
    SET_VIRTUAL_AVATAR_SELECT_AVATAR_BTN_DISABLE(state, payload) {
      state.select_avatar_btn_disable = payload
    }
  },
  actions: {
    async fetchVirtualAvatarList({ commit }) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.loading', Vuetify.locale.t('$vuetify.__InterfaceSetting.avatar.title')),
          loading: true
        })
        commit('SET_VIRTUAL_AVATAR_LOADING', true)
        const type_res = await api.getAvatarType()
        if (type_res.data.success) {
          const type = type_res.data.data.virtual_avatar_type
          commit('SET_VIRTUAL_AVATAR_TYPE', type)
          const avatars_res = type === 'video' ? await api.getVideoAvatarList() : await api.getVideoAvatarList() // await api.getAnimatedAvatarList()
          if (avatars_res.data.success) {
            commit('SET_VIRTUAL_AVATAR_AVATARS', avatars_res.data.data)
            commit('SET_VIRTUAL_AVATAR_LOADING', false)
            commit('SET_SNACKBAR', { status: false })
          } else throw Error(avatars_res.data.message)
        } else throw Error(type_res.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
        router.push({ path: '/interface' })
      }
    },
    async selectVirtualAvatar({ rootState, commit, dispatch }, avatar) {
      try {
        commit('SET_SNACKBAR', {
          status: true,
          color: 'loading',
          text: Vuetify.locale.t('$vuetify.__SnackBar.updating', Vuetify.locale.t('$vuetify.__InterfaceSetting.avatar.title')),
          loading: true
        })
        commit('SET_VIRTUAL_AVATAR_SELECT_AVATAR_BTN_DISABLE', true)

        const device_id = rootState.auth.selected_device

        const response = await api.updateVideoAvatar({ params: { device_id, avatar_id: avatar.id, is_in_use: !avatar.is_in_use } })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.success', ''), icon: 'check', timeout: '2000' })
          dispatch('fetchVirtualAvatarList')
        } else throw Error(response.data.error)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_VIRTUAL_AVATAR_SELECT_AVATAR_BTN_DISABLE', false)
      }
    }
  }
}
